import React, { useEffect, useState } from 'react';
import './HeroSection.css';
import posthog from 'posthog-js';
import youtubeLogo from '../images/youtube.png';
import twitchLogo from '../images/twitchs.svg';
import kickLogo from '../images/kick.svg';
import tiktokLogo from '../images/tiktok.svg';
import instagramLogo from '../images/instagram.svg';
import xLogo from '../images/twitter.png';
// import lipsIcon from '../images/Lips-Emoji-PNG-Pic.png';
// import eyeIcon from '../images/6502024cbfe9e66618625b5e56776702.png';

// Initialize PostHog
posthog.init('phc_WJldFUUt3A1FzP0I0arXjNUSqbgpifqkfucNemBKXKB', {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only'
});

function HeroSection() {
  const [stripeLink, setStripeLink] = useState('https://buy.stripe.com/cNibIT9dz6Wb2bk5zO2cg06');
  const [variant, setVariant] = useState(null);
  const [currentSubtitle, setCurrentSubtitle] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const subtitles = [
    { text: 'IRL STREAMING', logo: [twitchLogo, kickLogo, youtubeLogo, xLogo] },
    { text: 'VLOGGING', logo: youtubeLogo },
    { text: 'SHORT FORM', logo: [instagramLogo, tiktokLogo] }, // Placeholder, update as needed
  
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentSubtitle((prev) => (prev + 1) % subtitles.length);
        setIsTransitioning(false);
      }, 500); // Half of the transition time
    }, 3000); // Show each text for 3 seconds

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setStripeLink('https://buy.stripe.com/cNibIT9dz6Wb2bk5zO2cg06');
  }, []);

  const handleReservationClick = () => {
    // Track the reservation click event in PostHog
    posthog.capture('reservation_button_clicked');
    // Open the Stripe link in a new tab
    window.open(stripeLink, '_blank');
  };

  return (
    <div className="hero-container">
      <div className="hero-center-content">
        <div className="hero-content-inner">
          <div className="hero-title-block">
            <div className="hero-title-align-inner">
              <h1 className="company-subtitle">
                Share <em>Anything</em>
              </h1>
              <div className="hero-subtext">All day eyewear for content creators.</div>
              <button 
                onClick={handleReservationClick}
                className="reservation-button hero-reserve-btn"
              >
                RESERVE NOW
                <svg 
                  width="16" 
                  height="16" 
                  viewBox="0 0 24 24" 
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="arrow-icon"
                >
                  <path 
                    d="M5 12H19M19 12L12 5M19 12L12 19" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      <img src={process.env.PUBLIC_URL + '/images/waves.png'} alt="waves" className="waves-img-black" />
    </div>
  );
}

export default HeroSection;
